import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/NotFoundPage.head';
import { NotFoundPage } from '@pages/NotFoundPage';

export const Route = createFileRoute('/404')({
  component: NotFoundPage,
  head: () => head,
});
